import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Component that handles scrolling to hash sections after navigation
 * Ensures the page is fully loaded before attempting to scroll
 */
export default function HashScroller() {
  const location = useLocation();

  useEffect(() => {
    // Check if there's a hash in the URL
    if (location.hash) {
      // Remove the # from the hash
      const sectionId = location.hash.substring(1);
      
      // Small delay to ensure page is fully loaded and rendered
      const scrollToSection = () => {
        const element = document.getElementById(sectionId);
        if (element) {
          // Use setTimeout to ensure DOM is ready
          setTimeout(() => {
            element.scrollIntoView({ 
              behavior: 'smooth', 
              block: 'start' 
            });
          }, 100);
        } else {
          // If element not found yet, try again after a short delay
          setTimeout(() => {
            const retryElement = document.getElementById(sectionId);
            if (retryElement) {
              retryElement.scrollIntoView({ 
                behavior: 'smooth', 
                block: 'start' 
              });
            }
          }, 500);
        }
      };

      // Wait for the page to be ready
      if (document.readyState === 'complete') {
        scrollToSection();
      } else {
        window.addEventListener('load', scrollToSection);
        // Also try after a timeout as fallback
        setTimeout(scrollToSection, 300);
        
        // Cleanup
        return () => {
          window.removeEventListener('load', scrollToSection);
        };
      }
    }
  }, [location]);

  return null;
}
